import React from "react";
import styled from "styled-components";
const Market = (props) => {
    return (React.createElement(Wrapper, { onClick: () => props.updateMarket(props.market) },
        React.createElement(Text, { selected: props.selected }, props.market)));
};
const Wrapper = styled.div `
  background: ${({ theme }) => theme.markets.background};
  margin: 5px 12px 5px 0px;
  border-radius: 20px;
  cursor: pointer;
  width: max-content;

  @media (max-width: 768px): {
    font-size: 10px;
  }, 
`;
const Text = styled.p `
  margin: 0;
  color: ${({ theme }) => theme.markets.color};
  padding: 6px 8px 6px 8px;
  font-weight: ${(props) => (props.selected ? "bold" : "normal")};
`;
export default Market;
//# sourceMappingURL=Market.js.map